import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {WizardModule} from './views/modules/wizard/wizard.module';
import {CommonModule} from '@angular/common';
import {DisplayConsentModule} from './views/modules/display-consent/display-consent.module';
import {StoreModule} from '@ngrx/store';
import {SharedModule} from '@shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {MatRadioModule} from '@angular/material/radio';
import {AdminGuard} from '../../auth/keycloak-admin.guard';
import {LandingRedirectModule} from './views/modules/landing-redirect/landing-redirect.module';
import {LandingRedirectComponent} from './views/modules/landing-redirect/landing-redirect.component';
import {UserManagementModule} from './views/modules/user-management/user-management.module';
import {CmsModule} from './views/modules/cms/cms.module';
import {CoreReducer} from '@core/store';
import {DataProcessingGuard} from './views/modules/data-processing/guard/data-processing.guard';
import {BasicDisplayConsentModule} from './views/modules/basic-display-consent/basic-display-consent.module';
import {FileUploadModule} from './views/modules/file-upload/file-upload.module';


const routes: Routes = [
    {
        path: 'submitted-consents',
        loadChildren: () => import('./views/modules/review-consent/review-consent.module').then(module => module.ReviewConsentModule)
    },
    {
        path: 'welcome',
        loadChildren: () => import ('./views/modules/welcome-page/welcome.module').then(module => module.WelcomeModule),
        canActivate: [DataProcessingGuard]
    },
    {
        path: 'wizard',
        loadChildren: () => import('./views/modules/wizard/wizard.module').then(module => module.WizardModule)
    },
    {
        path: 'consent',
        loadChildren: () => import('./views/modules/display-consent/display-consent.module').then(module => module.DisplayConsentModule)
    },
    {
        path: 'export',
        loadChildren: () => import('./views/modules/admin/admin.module').then(module => module.AdminModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'questionnaire',
        loadChildren: () => import('./views/modules/anamnesis-questionnaire/anamnesis.module').then(module => module.AnamnesisModule)
    },
    {
        path: 'consent-overview',
        loadChildren: () => import ('./views/modules/consent-overview/consent-overview.module').then(module => module.ConsentOverviewModule)
    },
    {
        path: 'user-management',
        loadChildren: () => import ('./views/modules/user-management/user-management.module').then(module => module.UserManagementModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'single-comment',
        loadChildren: () => import ('./views/modules/single-comment/single-comment.module').then(module => module.SingleCommentModule)
    },
    {
        path: 'form',
        loadChildren: () => import ('./views/modules/questionnaire/questionnaire.module').then(module => module.QuestionnaireModule)
    },
    {
        path: 'settings',
        loadChildren: () => import ('./views/modules/user-settings/user-settings.module').then(module => module.UserSettingsModule)
    },
    {
        path: 'cms',
        loadChildren: () => import ('./views/modules/cms/cms.module').then(module => module.CmsModule)
    },
    {
        path: 'basic',
        loadChildren: () => import ('./views/modules/basic-display-consent/basic-display-consent.module').then(module => module.BasicDisplayConsentModule)
    },
    {
        path: 'manage',
        loadChildren: () => import ('./views/modules/super-admin/super-admin.module').then(module => module.SuperAdminModule)
    },
    {
        path: 'medication-management',
        loadChildren: () => import ('./views/modules/medication-management/medication-management.module').then(module => module.MedicationManagementModule),
        canActivate: [AdminGuard]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
        StoreModule.forFeature(CoreReducer.REDUCER_NAME, CoreReducer.coreReducer),
        WizardModule,
        DisplayConsentModule,
        BasicDisplayConsentModule,
        LandingRedirectModule,
        CommonModule,
        SharedModule,
        TranslateModule,
        MatRadioModule,
        UserManagementModule,
        CmsModule,
        FileUploadModule
    ],
    declarations: [
        LandingRedirectComponent
    ],
    providers: []
})
export class SecuredModule {

}
